import { Box, Divider, Grid, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import TextMark from '../text/TextMark';

const CardSearchNav = ({
    itemsProsp,
    item,
    titulo,
    descripcion,
    setOpen,
    onClick,
    onCLoseModal,
    textSearch,
    isDarkMode: isDarkModeProp
}) => {
    const theme = useTheme();
    const isDarkMode = isDarkModeProp !== undefined ? isDarkModeProp : theme.palette.mode === 'dark';
    const navigate = useNavigate();
    const redirectOnClick = () =>{
        if(onClick){
            onClick(item)
        }else{

            if(item?.id_tk > 0){
                navigate(`/ticket/${item?.id_tk}/nubicom`);
            }
            if(item?.cuenta){
                navigate(`/contactos/${item.cuenta}/cuenta`)
            }
            if(item?.id_c){
                navigate(`/contactos/${item.id_c}/nubicom`)
            }
            if(item?.id_t){
                if(item?.cuenta){
                    navigate(`/servicio/${item?.id_t}/cuenta`)
                }else{
                    navigate(`/pre-servicio/${item?.id_t}/nubicom`)
                }
            }
            if(item?.nroTk){
                navigate(`/ticket/${item?.nroTk}/nubicom`);
            }
            if(onCLoseModal){
                onCLoseModal()
            }
            if(item?.contactoCuenta_con){
                navigate(`/contactos/${item.contactoCuenta_con}/cuenta`)
            }
            if(item?.contactoId_con){
                navigate(`/contactos/${item?.contactoId_con}/nubicom`)
            }
        }
        if(setOpen){
            setOpen(false)
        }
    }
    function extractNumbersFromDescription(descripcion) {
        const matches = descripcion.match(/DNI\/CUIT: (\d+)/);
        return matches ? matches[1] : '';
    }
    function extractAccountNumberFromDescription(descripcion) {
        const matches = descripcion.match(/N° CUENTA: (\d+)/);
        return matches ? matches[1] : '';
    }
    function isExpectedFormat(descripcion) {
        return /^DNI\/CUIT: \d+ - N° CUENTA: \d+ - TEL: .+$/.test(descripcion);
    }
    function hasAccountNumber(descripcion) {
        return /N° CUENTA: \d+/.test(descripcion);
    }
    function extractTelefonoFromDescription(descripcion) {
        const matches = descripcion.match(/TEL: ([^\n\r]+)/);
        return matches ? matches[1] : '-';
    }
    return (
        <Box
            {...itemsProsp}
            onClick={(e)=>{
                redirectOnClick();
                if(itemsProsp?.onClick){
                    itemsProsp.onClick(e);
                }
            }}
            sx={{
                background: isDarkMode ? '#1F2A40' : '#fff',
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                borderLeft: item?.dni_cuit?.blacklist 
                    ? '3px solid #d32f2f' 
                    : isDarkMode ? '3px solid #64B5F6' : '3px solid #0364ff',
                borderRadius: '6px',
                mb: 0.5,
                transition: 'all 0.15s ease',
                overflow: 'hidden',
                '&:hover':{
                    background: isDarkMode ? '#2d3a52' : '#fafafa',
                    cursor: 'pointer',
                    boxShadow: isDarkMode ? '0 1px 4px rgba(0,0,0,0.3)' : '0 1px 4px rgba(0,0,0,0.1)',
                    borderLeftWidth: '4px'
                }
            }}
        >
            <Box sx={{px: {xs: 1, sm: 1.5}, py: {xs: 0.8, sm: 1}}}>
                <Grid container spacing={1} alignItems='center'>
                    {/* Logo/Avatar - Compacto */}
                    <Grid item xs="auto" display='flex' alignItems='center'>
                        <Box sx={{
                            width: {xs: 32, sm: 36},
                            height: {xs: 32, sm: 36},
                            border: isDarkMode ? '1.5px solid #3d4a62' : '1.5px solid #e0e0e0',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: isDarkMode ? '#2d3a52' : '#fafafa',
                            flexShrink: 0
                        }}>
                            <img 
                                src="/img/nubi-cirucular.png" 
                                alt="Icon" 
                                style={{
                                    width: '28px', 
                                    height: '28px',
                                    objectFit: 'contain'
                                }} 
                            />
                        </Box>
                    </Grid>
                    
                    {/* Contenido Principal */}
                    <Grid item xs>
                        <Box display='flex' flexDirection='column' gap={0.3}>
                            {/* Título */}
                            <Typography
                                component='div'
                                sx={{
                                    color: isDarkMode ? '#e0e0e0' : '#202124',
                                    fontWeight: 700,
                                    fontSize: {xs: 11, sm: 12},
                                    lineHeight: 1.3,
                                    wordBreak: 'break-word'
                                }}
                            >
                                <TextMark texto={titulo || ''} textMark={textSearch || ''} />
                            </Typography>
                            
                            {/* Descripción */}
                            <Typography
                                component='div'
                                sx={{
                                    color: isDarkMode ? '#a0a0a0' : '#5f6368',
                                    fontSize: {xs: 9.5, sm: 10},
                                    lineHeight: 1.4,
                                    fontWeight: 400
                                }}
                            >
                                {isExpectedFormat(descripcion) ? (
                                    <>
                                        <TextMark texto={`DNI/CUIT: `} textMark={textSearch || ''} />
                                        {hasAccountNumber(descripcion) ? (
                                            <>
                                                <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                    <TextMark
                                                        texto={extractNumbersFromDescription(descripcion)}
                                                        textMark={textSearch || ''}
                                                    />
                                                </Box>
                                                <TextMark texto=" - N° CUENTA: " textMark={textSearch || ''} />
                                                <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                    <TextMark
                                                        texto={extractAccountNumberFromDescription(descripcion)}
                                                        textMark={textSearch || ''}
                                                    />
                                                </Box>
                                                <TextMark texto=" - TEL: " textMark={textSearch || ''} />
                                                <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                    <TextMark
                                                        texto={extractTelefonoFromDescription(descripcion)}
                                                        textMark={textSearch || ''}
                                                    />
                                                </Box>
                                            </>
                                        ) : (
                                            <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                <TextMark
                                                    texto={extractNumbersFromDescription(descripcion)}
                                                    textMark={textSearch || ''}
                                                />
                                            </Box>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {extractNumbersFromDescription(descripcion) ? (
                                            <>
                                                <TextMark texto={`DNI/CUIT: `} textMark={textSearch || ''} />
                                                <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                    <TextMark
                                                        texto={extractNumbersFromDescription(descripcion) || 'S/N'}
                                                        textMark={textSearch || ''}
                                                    />
                                                </Box>
                                                <TextMark texto=" - TEL: " textMark={textSearch || ''} />
                                                <Box component="span" sx={{fontWeight: 600, color: isDarkMode ? '#e0e0e0' : '#202124'}}>
                                                    <TextMark
                                                        texto={extractTelefonoFromDescription(descripcion)}
                                                        textMark={textSearch || ''}
                                                    />
                                                </Box>
                                            </>
                                        ):(
                                            <TextMark texto={descripcion || ''} textMark={textSearch || ''} />
                                        )}
                                    </>
                                )}
                            </Typography>
                            
                            {/* Alerta de blacklist */}
                            {item?.dni_cuit?.blacklist && (
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        mt: 0.3,
                                        px: 0.8,
                                        py: 0.3,
                                        backgroundColor: isDarkMode ? '#3d1a1a' : '#ffebee',
                                        border: isDarkMode ? '1px solid #5d2a2a' : '1px solid #ffcdd2',
                                        borderRadius: '4px',
                                        width: 'fit-content'
                                    }}
                                >
                                    <Typography 
                                        sx={{
                                            color: '#d32f2f', 
                                            fontWeight: 700, 
                                            fontSize: {xs: 9, sm: 10},
                                            lineHeight: 1.2
                                        }}
                                    >
                                        ⚠ Cliente no apto para la venta
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default CardSearchNav